import { TreeSelect as TreeSelects } from 'primereact/treeselect';  

const TreeSelect = ({...rest}) => {

    return (
        <TreeSelects {...rest} />
    )

};

export default TreeSelect;